export default "__VITE_ASSET__9493c0a2__"